import { RoutesService, eLayoutType } from '@abp/ng.core';
import { inject, provideAppInitializer } from '@angular/core';
export const APP_ROUTE_PROVIDER = [
  provideAppInitializer(() => {
    configureRoutes();
  }),
];
function configureRoutes() {
  const routes = inject(RoutesService);
  routes.add([
      {
        path: '/',
        name: '::Menu:Calibrations',
        iconClass: 'fa fa-gauge',
        order: 1,
        layout: eLayoutType.application,
      },
      {
        path: '/synchronization',
        name: '::Menu:Synchronization',
        iconClass: 'fas fa-sync',
        order: 2,
        layout: eLayoutType.application,
      },
      {
        path: '/calibration-history',
        name: '::Menu:CalibrationHistory',
        iconClass: 'fas fa-history',
        order: 3,
        layout: eLayoutType.application,
      }
  ]);
}
